export default {
  threadRow1: '杰为实时数字化链能够随时随地向团队提供创意和信息，助力更快更优的决策。先进的分析及AI功能自动从CAD，PLM，客户体验，工业IoT设备，供应链，质量系统，BOM中攫取数据集，解锁复杂关联，降低依赖性；实时同步功能确保所有相关用户始终获取最新的准确信息；自动化影响分析则显露设计变更、供应商延误、设备故障等问题的下游影响。'
}
